import {Map} from 'immutable';

import Audio from './Audio';

export default Map({
  renderer: Audio,
  type: 'audio',
  label: 'Audio'
});
